module.exports = __webpack_public_path__ + "static/google-play-badge-388affa7a1c8030281c3b8e90a3429a2.png";